import BlockingLoadingOverlayController from "src/ui/components/BlockingLoadingOverlay/BlockingLoadingOverlayController";

const startLoading = () =>
  BlockingLoadingOverlayController.startLoading({
    bg: "transparent",
    fadeIn: true,
    message: "shippingAddress.verification"
  });

const endLoading = () => BlockingLoadingOverlayController.endLoading();

const loadingError = () => BlockingLoadingOverlayController.loadingError();

const loadingSuccess = () =>
  BlockingLoadingOverlayController.loadingSuccess({
    message: "shippingAddress.verified"
  });

export const shippingAddressValidationCubitConstant = {
  startLoading,
  endLoading,
  loadingError,
  loadingSuccess
};
